import React from 'react';
import moment from 'moment';
import patientLogo from "../../../style/icons/Subscription/patient_active.svg";
// import editIcon from "../../../style/icons/PersonEdit/person-edit.svg"; // If needed

const SubscribersListItem = ({ items, t, edit, setEdit, handleDelete }) => (
  <>
    {items &&
      items.map((patient) =>
        patient.patientCards.map((card, i) => {
          if (card.relationShip.uniqueRelation === 1)
            return (
              <div key={i} className={`subscribersListItem`}>
                <img
                  className="subscriberAvatar"
                  src={card.photoUrl === "" ? patientLogo : card.photoUrl}
                  alt="user-avatar"
                />
                <p className="subscriberTitle">{t("patient")}</p>
                <p className="subscriberFullName">{card.fullName}</p>
                {card.insuranceCompanyName && (
                  <p className="subscriberInsuranceCompany">
                    <span className="text-grey">{t("insuranceCompany")}:</span>{" "}
                    {card.insuranceCompanyName}
                  </p>
                )}
                <p className="subscriberPoliceNumber">
                  <span className="text-grey">{t("policeNumber")}:</span>{" "}
                  {patient.policeNumber}
                </p>
                <p className="insuranceDateStart">
                  <span className="text-grey">{t("policeStartDate")}:</span>{" "}
                  {moment(patient.companySubscriptionBookedAt).format("L")}
                </p>
                <p className="insuranceDateEnd">
                  <span className="text-grey">{t("policeExpireDate")}:</span>{" "}
                  {moment(patient.companySubscriptionExpiredAt).format("L")}
                </p>
                <div className="subscriberFooter">
                  <div className="idBlock">
                    <span className="itemIdTitle">ID</span>
                    <span className="itemIdValue">#{card.id}</span>
                  </div>
                  {/*<img*/}
                  {/*  className="editIcon"*/}
                  {/*  src={editIcon}*/}
                  {/*  alt="edit icon"*/}
                  {/*  onClick={() => {*/}
                  {/*    setEdit();*/}
                  {/*  }}*/}
                  {/*/>*/}
                </div>
                <div className='deleteSubscriber'>
                  <button onClick={() => handleDelete(card.patientId)} className='deleteSubButton'>{t("deletePromocode")}</button>
                </div>
              </div>
            );
        })
      )}
  </>
);

export default SubscribersListItem; 